<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.shipping_num"
                    placeholder="快递单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="form.dbid" placeholder="打标id"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.work_id"
                    placeholder="工单id"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.da_biao_status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.to_where"
                    placeholder="入库仓区"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.dbid_to_where"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="拆包提交时间：">
                  <el-date-picker
                    v-model="form.unpack_submit_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <div
      v-if="form.shipping_num && resData.base_info"
      style="margin-bottom: 20px"
    >
      <div class="galy-header">寄回运单号:{{ form.shipping_num }}</div>
      <el-row :spa="50" style="margin-top: 10px">
        <el-col :span="11" class="border">
          <el-col :span="8">
            <p>用户id: {{ resData.base_info.user_id }}</p>
            <p>
              包裹状态:
              {{ resData.base_info.as_package_package_status }}
            </p>
          </el-col>
          <el-col :span="8">
            <p>接收人: {{ resData.base_info.receive_admin }}</p>
            <p>是否破损: {{ resData.base_info.is_broken }}</p>
          </el-col>
          <el-col :span="8">
            <p>接收时间: {{ resData.base_info.receive_time }}</p>
          </el-col>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="11" class="border">
          <el-col :span="6" style="border-right: #ccc dashed 1px">
            <p>工单数量: {{ resData.base_info.work_num }}</p>
            <p>工单商品数量: {{ resData.base_info.goods_number }}</p>
          </el-col>
          <el-col :span="6" style="padding-left: 20px">
            <p>拆包数量: {{ resData.base_info.unpack_num }}</p>
          </el-col>
          <el-col :span="6">
            <p>正常品: {{ resData.base_info.normal_num }}</p>
            <p>退换货: {{ resData.base_info.thh_num }}</p>
          </el-col>
          <el-col :span="6">
            <p>次品: {{ resData.base_info.cp_num }}</p>
            <p>无数据: {{ resData.base_info.no_data_goods_num }}</p>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          点货明细(不含无数据)
        </div>
        <div v-if="resData.list" style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              show-overflow-tooltip
              label="序号"
              width="100"
              type="index"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="dbid"
              label="打标id"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="goods_name"
              label="商品名称"
              width="250"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="goods_no"
              label="货号"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="co_val"
              label="颜色"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="si_val"
              label="尺码"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="sku"
              label="sku"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="work_id"
              label="工单id"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="blp_type"
              label="登记类型"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="problem_size"
              label="次品问题尺寸"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="problem_type"
              label="问题类型"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="dbid_to_where"
              label="入库仓区"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="desk_no"
              label="工作台"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="blp_note"
              label="备注"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="create_time"
              label="打标时间"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="admin_name"
              label="拆包人"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="da_biao_record_status"
              label="状态"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="stock_in_time"
              label="入库时间"
              width="200"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="exchange_calc_date"
              label="计算开始时间"
              width="200"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      form: {
        pagesize: 50,
        shipping_num: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/AsPackage/getAsPackageDetail",
      curPage: 1,
      filterFold: false,
      isAll: false,
      searchOptions: {},
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchCondition() {
      if (this.$route.query.shipping_num) {
        this.reset();
      }
      this.$set(
        this.form,
        "shipping_num",
        this.$route.query.shipping_num || ""
      );

      this.$http
        .post("/erp/AsPackage/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
          }
        });
      if (this.$route.query.shipping_num) {
        this.fetchData(true);
      }
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      let multipleSelection = [];
      this.multipleSelection = multipleSelection;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          console.log(this.resData);
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      var result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.form = {
        page: 1,
        pagesize: 50,
        receive_time: this.$excalibur.getDateTimeOnHours(-2, 6),
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
.galy-header {
  padding: 5px 10px;
  background-color: #eee;
}
.border {
  border: 1px solid #ccc;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/aspackage/AsPackageDetail.vue